var _style, _path, _path2, _line, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgInstagramFull = function SvgInstagramFull(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#0C586C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#0C586C;stroke:#0C586C;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,2h10c2.8,0,5,2.2,5,5v10c0,2.8-2.2,5-5,5H7c-2.8,0-5-2.2-5-5V7C2,4.2,4.2,2,7,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,21.6H6.2c-1.9,0-3.5-1.5-3.5-3.5V6.4c0-1.9,1.5-3.5,3.5-3.5h11.7c1.9,0,3.5,1.5,3.5,3.5v11.7 C21.4,20,19.8,21.6,17.9,21.6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 17.5,
    y1: 6.5,
    x2: 17.5,
    y2: 6.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,11.4c0.3,2.2-1.2,4.2-3.4,4.5c-2.2,0.3-4.2-1.2-4.5-3.4C7.8,10.4,9.3,8.3,11.5,8c0.4-0.1,0.8-0.1,1.2,0 C14.4,8.3,15.7,9.6,16,11.4z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagramFull);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbHF1ZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMEM1ODZDO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cgkuc3Qxe2ZpbGw6IzBDNTg2QztzdHJva2U6IzBDNTg2QztzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qye2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNywyaDEwYzIuOCwwLDUsMi4yLDUsNXYxMGMwLDIuOC0yLjIsNS01LDVIN2MtMi44LDAtNS0yLjItNS01VjdDMiw0LjIsNC4yLDIsNywyeiIvPgo8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTcuOSwyMS42SDYuMmMtMS45LDAtMy41LTEuNS0zLjUtMy41VjYuNGMwLTEuOSwxLjUtMy41LDMuNS0zLjVoMTEuN2MxLjksMCwzLjUsMS41LDMuNSwzLjV2MTEuNwoJQzIxLjQsMjAsMTkuOCwyMS42LDE3LjksMjEuNnoiLz4KPGxpbmUgY2xhc3M9InN0MiIgeDE9IjE3LjUiIHkxPSI2LjUiIHgyPSIxNy41IiB5Mj0iNi41Ii8+CjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xNiwxMS40YzAuMywyLjItMS4yLDQuMi0zLjQsNC41Yy0yLjIsMC4zLTQuMi0xLjItNC41LTMuNEM3LjgsMTAuNCw5LjMsOC4zLDExLjUsOGMwLjQtMC4xLDAuOC0wLjEsMS4yLDAKCUMxNC40LDguMywxNS43LDkuNiwxNiwxMS40eiIvPgo8L3N2Zz4K";